import {
  Button,
  Col,
  Form,
  FormControl,
  FormGroup,
  FormLabel,
  Modal,
  Row,
} from "@themesberg/react-bootstrap";
import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSave,
  faTrash,
  faWindowClose,
} from "@fortawesome/free-solid-svg-icons";
import { axiosInstance } from "../../../../config/axios";
import { APIURL } from "../../../../configApi";
import { NotificationManager } from "react-notifications";
import couriers from "../index";

const ShowAssistant = (props) => {
  const { showForm, assistant, closeForm } = props;

  const [first_name, setFirst_name] = useState("");
  const [last_name, setLast_name] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [full_address, setFull_address] = useState("");
  const [principal_phone, setPrincipal_phone] = useState("");

  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    // console.log("courier => ", assistant)
    setFirst_name(assistant.first_name);
    setLast_name(assistant.last_name);
    setDescription(assistant.description);
    setEmail(assistant.email);
    setCity(assistant.city);
    setState(assistant.state);
    setPrincipal_phone(assistant.principal_phone);
    setFull_address(assistant.full_address);
  }, [assistant]);

  return (
    <>
      {assistant && (
        <Modal
          as={Modal.Dialog}
          centered
          show={showForm}
          onHide={closeForm}
          size={"lg"}
        >
          <Modal.Header>
            <Modal.Title className="h4 text-main">
              {" "}
              <span className={"text-center"}>Détail de l'assistant(e) </span>
            </Modal.Title>
            <Button variant="close" aria-label="Close" onClick={closeForm} />
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={6} sm={12}>
                <h5>
                  Nom : <span className={"text-success"}> {first_name} </span>
                </h5>
              </Col>
              <Col md={6} sm={12}>
                <h5>
                  Prénom : <span className={"text-success"}> {last_name} </span>
                </h5>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col md={6} sm={12}>
                <h5>
                  Email : <span className={"text-success"}> {email} </span>
                </h5>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col md={6} sm={12}>
                <h5>
                  Ville :{" "}
                  <span className={"text-success"}>
                    {" "}
                    {city?.name} ( {state?.name} ){" "}
                  </span>
                </h5>
              </Col>
              <Col md={6} sm={12}>
                <h5>
                  Téléphone :{" "}
                  <span className={"text-success"}> {principal_phone} </span>
                </h5>
              </Col>
            </Row>
            <hr />

            <div>
              <h5>
                Adresse : <span className={"text-success"}>{full_address}</span>
              </h5>
            </div>
            <hr />
            <div>
              <h5>
                Déscription :{" "}
                <span className={"text-success"}>{description}</span>
              </h5>
            </div>

            {/*<div className="my-4 d-flex justify-content-end">*/}

            {/*    <Button variant={'main'} onClick={closeForm}> <FontAwesomeIcon icon={faWindowClose}/> Fermer*/}
            {/*    </Button>*/}
            {/*</div>*/}
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default ShowAssistant;
